import React from "react";
import Nav from "../components/Nav";
import FooterCertificates from "../components/FooterCertificates";
import Footer from "../components/Footer";
import CareersForm from "../config/CareersForm";
import { useLanguage } from "../config/LanguageContext";
import Vacancies from "../components/Vacancies";
import { Helmet } from "react-helmet";

function Careers() {
  const { currentLanguage, translations } = useLanguage();
  const content =
    translations?.careers?.[currentLanguage] || translations?.careers?.en;

  return (
    <>
      <Helmet>
        <title>Careers</title>
        <meta name="description" content="Explore our opportunities" />
      </Helmet>
      <Nav />
      <div className="careers-container">
        <div className="about-us-header">
          <div className="careers-header-container">
            <h1 className="gray">{content.title}</h1>
          </div>
        </div>
        <div className="upside-down-left-to-right-triangle-secondary"></div>
        <div className="careers-wrapper">
          <div>
            <h2>{content.why?.[0]?.header}</h2>
            {content.why?.[0]?.text?.map((item, index) => (
              <p key={index}>{item}</p>
            ))}
          </div>
          <div>
            <h2>{content.about?.[0]?.header}</h2>
            {content.about?.[0]?.text?.map((item, index) => (
              <p key={index}>{item}</p>
            ))}
          </div>
          <div>
            <h2>{content.recruitment?.[0]?.header}</h2>
            {content.recruitment?.[0]?.text?.map((item, index) => (
              <p key={index}>{item}</p>
            ))}
          </div>
        </div>
      </div>
      <Vacancies />
      <div className="left-to-right-triangle"></div>
      <div className="interest-section-container">
        <div className="interest-section-wrapper">
          <h2>{content.interest?.header}</h2>
          <p>{content.interest?.text}</p>
        </div>
        <div className="book-demo-form-container">
          <CareersForm />
        </div>
      </div>
      <div className="upside-down-left-to-right-triangle"></div>
      <FooterCertificates />
      <Footer />
    </>
  );
}

export default Careers;
